/* This is a generated file. Do not edit manually. */
import React from 'react';
import PropTypes from 'prop-types';
import iconSizes from '../../iconSizes';

/**
 * VolumeDownIcon
 */
export default class VolumeDownIcon extends React.Component {
  static propTypes = {
    /** The size of the icon */
    size: PropTypes.oneOf(['s', 'm', 'l', 'xl']),
    /** The color of the icon */
    color: PropTypes.string.isRequired
  };

  static defaultProps = {
    size: 'm',
    color: 'black'
  };

  render() {
    const { size: sizeProp, color } = this.props;
    const size = correctButtonSize(sizeProp);
    return (
      <svg
        focusable="false"
        xmlns="http://www.w3.org/2000/svg"
        viewBox={'0 0 32 32'}
        style={{ width: iconSizes[size], height: iconSizes[size] }}
      >
        <g style={{ fill: color }}>
          <svg viewBox="0 0 24 24"><path d="M14 4.414a2 2 0 012 2v11.172A2 2 0 0112.586 19l-3-3H7a2 2 0 01-2-2v-4a2 2 0 012-2h2.586l3-3A2 2 0 0114 4.414zm0 2l-3.293 3.293A1 1 0 0110 10H7v4h3a1 1 0 01.707.293L14 17.586V6.414zm3.553.692a1 1 0 011.341.447C19.63 9.02 20 10.507 20 12c0 1.493-.371 2.979-1.106 4.447a1 1 0 01-1.788-.894c.599-1.198.894-2.38.894-3.553s-.295-2.355-.894-3.553a1 1 0 01.447-1.341z" fillRule="nonzero"/></svg>
        </g>
      </svg>
    );
  }
}

/* corrects deprecated api, can be removed in future release */
function correctButtonSize(size) {
  switch (size) {
    case 'medium':
      return 'm';
    case 'small':
      return 's';
    case 'large':
      return 'l';
    case 'xlarge':
      return 'xl';
    default:
      return size;
  }
}

